import { render } from "./TestUnits.vue?vue&type=template&id=6c3a8e26&scoped=true"
import script from "./TestUnits.vue?vue&type=script&lang=js"
export * from "./TestUnits.vue?vue&type=script&lang=js"

import "./TestUnits.vue?vue&type=style&index=0&id=6c3a8e26&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3a8e26"]])

export default __exports__